import { render, staticRenderFns } from "./CollapsePanel.vue?vue&type=template&id=48cee5d7&scoped=true"
import script from "./CollapsePanel.vue?vue&type=script&lang=js"
export * from "./CollapsePanel.vue?vue&type=script&lang=js"
import style0 from "./CollapsePanel.vue?vue&type=style&index=0&id=48cee5d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cee5d7",
  null
  
)

export default component.exports